// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;There shall they be in great fear;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for God is in the company of the righteous.<br> </p> </div></div>";
// Exports
module.exports = code;